<template>
  <section class="page-header" :style="{
      backgroundColor: currentBackgroundColor,
      color: currentTextColor
  }">
    <b-container>
      <b-row>
        <b-col cols="2">
          <b-link v-if="backLink" class="text-white" :to="backLink">
            <b-icon-chevron-left></b-icon-chevron-left>
          </b-link>
        </b-col>
        <b-col cols="8" class="text-center">
          {{ text }}
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  import {ref} from "@vue/composition-api";

  export default {
    name: "Banner",
    props: {
      'text': {type: String, required: true},
      'backLink': {type: Object, required: false, default: null},
      'backgroundColor': {default: '#BAC7DE'},
      'textColor': {default: '#ffffff'},
      },
    setup(props) {
      const currentTextColor = ref(props.textColor);
      const currentBackgroundColor = ref(props.backgroundColor);

      return {
        currentTextColor,
        currentBackgroundColor,
      }
    }
  }
</script>

<style>

  .page-header {
    font-family: 'Montserrat', sans-serif;
    transition: background-color 1s ease-in-out 0s;

    padding-top: .3rem;
    vertical-align: middle;
    color: white;
    min-height: 5rem;
    text-align: center;
    font-size: 48px;
    background-color: #BAC7DE;
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, .9);
    z-index: 100;

    text-transform: uppercase;
  }
  @media (max-width: 768px) {
    .page-header {
      font-size: 36px;
      min-height: 4rem;
    }
  }
</style>